import * as React from 'react';
import { connect } from 'react-redux';

import LocationListHeader from '../../components/locations/LocationListHeader';

import Loader from '~/common/components/Loader';


class OrgLocationHeader extends React.Component<any, any> {
  render() {
    const { orgId, organizations, locations, onCreate, onSearch, filter } = this.props;

    if (locations.ui.loading) {
      return (
        <Loader className="load--full" />
      );
    }

    const org = organizations.entities[orgId];
    let title = 'Locations';

    if (org) {
      title = `${org.name} - Locations`;
    }

    return (
      <LocationListHeader
        title={title}
        onFilter={onSearch}
        onCreate={onCreate}
        filter={filter}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    organizations: state.shared.organizations,
    locations: state.shared.locations,
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgLocationHeader);
